'use strict';
var util = require('../util');
var batchAPI = [
    'setLLButton',
    'setLRButton',
    'setRLButton',
    'setRRButton'
];

var Core = module.exports = {
    appVersion: '8.1.4',
    publish: function(opt) {
        var bizname = this._getBizName(opt);
        var CONSTS = ['phoneChanged', 'AccountBindChange'];
        if (/2Native/i.test(opt.type) || ~CONSTS.indexOf(opt.action)) {
            delete opt.type;
            this._send('publish', opt);
        } else if (bizname) {
            opt.action = bizname + ':' + opt.action;
            delete opt.type;
            this._send('publish', opt);
        }
    }
};

batchAPI.forEach(function (api) {
  Core[api] = _actionMapping(api);
});

function _actionMapping(method) {
    return function (opt) {
        if (opt && opt.icon) {
            opt.icon = _convertIcon(opt.icon);
        }
        this._send(method, opt);
    };
}

function _convertIcon(icon) {
    var mapList = {
        'H5_Favorite_On': 'ic_action_favorite_on_normal',
        'H5_Favorite_Off': 'ic_action_favorite_off_normal'
    };
    if (/android/i.test(util.osName)) {
        return mapList[icon] || icon;
    }
    return icon;
}


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/patch/patch-8.1.4.js
// module id = 560
// module chunks = 0